module.exports = __webpack_public_path__ + "static/media/IMG-20180730-WA0206.04d5928b.jpg";